module.exports = __webpack_public_path__ + "img/upload-success.4f32a4cb.png";